import { getDropdownOptions } from '../../../utils/dropdownUtils';
import * as types from '../services/CommonActionType';
import * as loginTypes from '../../login/services/LoginActionType';

function commonReducer(state = {}, action) {
    switch (action.type) {
        case types.GET_ROLES_REQUEST:
            return { ...state, loading: true };
        case types.GET_ROLES_SUCCESS:
            return { ...state, loading: false, roles: action.payload };
        case types.GET_ROLES_FAILURE:
            return { ...state, loading: false };

        case types.GET_STATUS_REQUEST:
            return { ...state, loading: true };
        case types.GET_STATUS_SUCCESS:
            return { ...state, loading: false, status: getDropdownOptions(action.payload) };
        case types.GET_STATUS_FAILURE:
            return { ...state, loading: false };

        case types.GET_DOCUMENT_MODULES_REQUEST:
            return { ...state, loading: true };
        case types.GET_DOCUMENT_MODULES_SUCCESS:
            return { ...state, loading: false, documentModules: getDropdownOptions(action.payload) };
        case types.GET_DOCUMENT_MODULES_FAILURE:
            return { ...state, loading: false };

        case types.GET_DOCUMENT_TYPES_REQUEST:
            return { ...state, loading: true };
        case types.GET_DOCUMENT_TYPES_SUCCESS:
            return { ...state, loading: false, documentTypes: getDropdownOptions(action.payload) };
        case types.GET_DOCUMENT_TYPES_FAILURE:
            return { ...state, loading: false };

        case types.GET_DOCUMENT_TYPES_WITH_CONFIGURATION_REQUEST:
            return { ...state, loading: true };
        case types.GET_DOCUMENT_TYPES_WITH_CONFIGURATION_SUCCESS:
            return { ...state, loading: false, documentTypesWithConfiguration: action.payload };
        case types.GET_DOCUMENT_TYPES_WITH_CONFIGURATION_FAILURE:
            return { ...state, loading: false };

        case types.GET_STORAGE_TYPES_REQUEST:
            return { ...state, loading: true };
        case types.GET_STORAGE_TYPES_SUCCESS:
            return { ...state, loading: false, storageTypes: action.payload };
        case types.GET_STORAGE_TYPES_FAILURE:
            return { ...state, loading: false };

        case types.GET_COMMUNICATION_TYPES_REQUEST:
            return { ...state, loading: true };
        case types.GET_COMMUNICATION_TYPES_SUCCESS:
            return { ...state, loading: false, communicationTypes: getDropdownOptions(action.payload) };
        case types.GET_COMMUNICATION_TYPES_FAILURE:
            return { ...state, loading: false };

        case types.GET_PRIORITY_TYPES_REQUEST:
            return { ...state, loading: true };
        case types.GET_PRIORITY_TYPES_SUCCESS:
            return { ...state, loading: false, priorityTypes: getDropdownOptions(action.payload) };
        case types.GET_PRIORITY_TYPES_FAILURE:
            return { ...state, loading: false };

        case types.GET_RECIPIENT_GROUP_REQUEST:
            return { ...state, loading: true };
        case types.GET_RECIPIENT_GROUP_SUCCESS:
            return { ...state, loading: false, recipientGroup: getDropdownOptions(action.payload) };
        case types.GET_RECIPIENT_GROUP_FAILURE:
            return { ...state, loading: false };

        case types.GET_USERS_FOR_DD_REQUEST:
            return { ...state, loading: true };
        case types.GET_USERS_FOR_DD_SUCCESS:
            return { ...state, loading: false, users: getDropdownOptions(action.payload) };
        case types.GET_USERS_FOR_DD_FAILURE:
            return { ...state, loading: false };

        case types.GET_INVESTORS_FOR_DD_REQUEST:
            return { ...state, loading: true };
        case types.GET_INVESTORS_FOR_DD_SUCCESS:
            return { ...state, loading: false, investors: getDropdownOptions(action.payload) };
        case types.GET_INVESTORS_FOR_DD_FAILURE:
            return { ...state, loading: false };

        case types.GET_EQUITY_TYPE_CLASS_REQUEST:
            return { ...state, loading: true };
        case types.GET_EQUITY_TYPE_CLASS_SUCCESS:
            // Store classes by equity type ID
            const equityTypeId = action.payload.equityTypeId || action.equityTypeId;
            const classes = getDropdownOptions(action.payload.data || action.payload);
            return {
                ...state,
                loading: false,
                equityTypeClasses: {
                    ...(state.equityTypeClasses || {}),
                    [equityTypeId]: classes
                }
            };
        case types.GET_EQUITY_TYPE_CLASS_FAILURE:
            return { ...state, loading: false };

        case types.DOCUMENT_DOWNLOAD_REQUEST:
            return { ...state, loading: true };
        case types.DOCUMENT_DOWNLOAD_SUCCESS:
            return { ...state, loading: false, downloadContent: action.payload };
        case types.DOCUMENT_DOWNLOAD_FAILURE:
            return { ...state, loading: false };

        case types.UPDATE_COMMON_REDUCER:
            return { ...state, ...action.payload };

        case loginTypes.LOGOUT_SUCCESS:
            window.sessionStorage.removeItem('selectedAuthorizedUser');
            return { ...state, selectedRole: null, selectedAuthorizedUser: null, showResetPasswordModal: false };

        case loginTypes.LOGIN_SUCCESS:
            window.sessionStorage.removeItem('selectedAuthorizedUser');
            return { ...state, selectedAuthorizedUser: null, showResetPasswordModal: false };

        case types.GET_HOLDCO_USER_REQUEST:
            return { ...state, isUserLoading: true };
        case types.GET_HOLDCO_USER_SUCCESS:
            return { ...state, isUserLoading: false, holdCoUserList: action.payload };
        case types.GET_HOLDCO_USER_FAILURE:
            return { ...state, isUserLoading: false, holdCoUserList: [] };

        case types.GET_STATUS_BY_TYPE_REQUEST:
            return { ...state, loading: true };
        case types.GET_STATUS_BY_TYPE_SUCCESS:
            // Store status by type
            const statusType = action.payload.type || action.type;
            const statusOptions = getDropdownOptions(action.payload.data || action.payload);
            return {
                ...state,
                loading: false,
                statusByType: {
                    ...(state.statusByType || {}),
                    [statusType]: statusOptions
                }
            };
        case types.GET_STATUS_BY_TYPE_FAILURE:
            return { ...state, loading: false };
        case types.GET_USER_DETAILS_REQUEST:
            return { ...state, isUserDetailsLoading: true };

        case types.GET_USER_DETAILS_SUCCESS:
            return { ...state, isUserDetailsLoading: false, userDetails: action.payload };

        case types.GET_USER_DETAILS_FAILURE:
            return { ...state, isUserDetailsLoading: false };

        case types.SAVE_CONTACT_US_REQUEST:
            return { ...state, isContactUsLoading: true, isContactUsSaved: false, contactUsMessage: null };

        case types.SAVE_CONTACT_US_SUCCESS:
            return { ...state, isContactUsLoading: false, isContactUsSaved: true, contactUsMessage: action.payload?.message || null };

        case types.SAVE_CONTACT_US_FAILURE:
            return { ...state, isContactUsLoading: false, isContactUsSaved: false };
        case types.RESET_CONTACT_US_STATUS:
            return { ...state, isContactUsSaved: false };

        case types.SAVE_DATA_UPLOAD_CENTER_REQUEST:
            return { ...state, isDataUploadCenterLoading: true };
        case types.SAVE_DATA_UPLOAD_CENTER_SUCCESS:
            return { ...state, isDataUploadCenterLoading: false };
        case types.SAVE_DATA_UPLOAD_CENTER_FAILURE:
            return { ...state, isDataUploadCenterLoading: false };

        case types.DELETE_NOTIFICATION_FILE_REQUEST:
            return { ...state, isDataUploadCenterLoading: true };
        case types.DELETE_NOTIFICATION_FILE_SUCCESS:
            return { ...state, isDataUploadCenterLoading: false };
        case types.DELETE_NOTIFICATION_FILE_FAILURE:
            return { ...state, isDataUploadCenterLoading: false };

        case types.GET_CATEGORY_FOR_DROPDOWN_REQUEST:
            return { ...state, loading: true };
        case types.GET_CATEGORY_FOR_DROPDOWN_SUCCESS:
            return { ...state, loading: false, categories: getDropdownOptions(action.payload) };
        case types.GET_CATEGORY_FOR_DROPDOWN_FAILURE:
            return { ...state, loading: false };
        case types.GET_CLASSIFICATION_REQUEST:
            return { ...state, loading: true };
        case types.GET_CLASSIFICATION_SUCCESS:
            return { ...state, classificationList: action.payload };
        case types.GET_CLASSIFICATION_FAILURE:
            return { ...state, classificationList: [] };

        case types.SET_AUTHORIZED_USER:
            // Persist to session storage
            try {
                window.sessionStorage.setItem('selectedAuthorizedUser', JSON.stringify(action.payload));
            } catch (e) {}
            return { ...state, selectedAuthorizedUser: action.payload };

        default:
            return state;
    }
}
export default commonReducer;